"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Token721 = void 0;
const token_1 = require("./token");
/**
 * Represents an ERC20 token with a unique address and some metadata.
 */
class Token721 extends token_1.Token {
    constructor(chainId, address, symbol, name) {
        super(chainId, address, 0, symbol, name);
    }
}
exports.Token721 = Token721;
